import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue";
import { ref, watch } from '../../../adapter-vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    zIndex: {
      default: 9999
    },
    useMask: {
      type: Boolean,
      default: true
    },
    maskColor: {
      default: 'rgba(0, 0, 0, 0.6)'
    },
    isFullScreen: {
      type: Boolean,
      default: true
    }
  },
  emits: ['onOverlayClick'],
  setup(__props, _ref) {
    var {
      expose: __expose,
      emit: __emit
    } = _ref;
    var emits = __emit;
    var props = __props;
    var overlayDomRef = ref();
    var isOverlayShow = ref(props.visible);
    watch(() => props.visible, visible => {
      if (visible) {
        isOverlayShow.value = true;
      } else {
        setTimeout(() => {
          isOverlayShow.value = false;
        }, 150);
      }
    }, {
      immediate: true
    });
    function onOverlayClick() {
      emits('onOverlayClick');
    }
    __expose({
      overlayDomRef
    });
    return (_ctx, _cache) => {
      return _unref(isOverlayShow) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "overlayDomRef",
        ref: overlayDomRef,
        class: "overlay",
        style: _normalizeStyle({
          position: props.isFullScreen ? 'fixed' : 'absolute',
          zIndex: props.zIndex
        }),
        onClick: onOverlayClick
      }, [props.useMask ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({
          'overlay-mask': true,
          'fade-in': props.visible
        }),
        style: _normalizeStyle({
          backgroundColor: props.maskColor
        })
      }, null, 6)) : _createCommentVNode("", true), _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, [_renderSlot(_ctx.$slots, "default")])], 4)) : _createCommentVNode("", true);
    };
  }
});